export default __webpack_public_path__ + "static/media/Neck.d078f750.svg";